module.exports = {
	"Search the video": "Поиск в видео",
	"Explore": "Просмотр данных",
	"Print": "Печать",
	"Download": "Скачать",
	"Share": "Поделиться",
	"Settings": "Настройки",
	"Language": "Язык",
	"Interface Language": "Язык интерфейса",
	"Transcript / Captions Language": "Язык текста / субтитров",
	"Transcript Language": "Язык текста",
	"Captions Language": "Язык субтитров",
	"Show Transcript": "Показывать текст",
	"Show Captions": "Показывать субтитры",
	"Show Heatmap": "Показывать карту популярности",
	"Show Speakers in Transcript": "Показывать говорящих в тексте",
	"Keyword": "ключевое слово",
	"Keywords": "Ключевые слова",
	"Topic": "Тема",
	"Topics": "Темы",
	"Speaker": "Говорящий",
	"Speakers": "Говорящие",
	"Transcript": "Текст",
	"Previous": "Предыдущий",
	"Next": "Следующий",
	"Clear": "Очистить",
	"No results found": "Нет результатов",
	"try another search or explore": "измените поиск или просмотрите имеющиеся",
	"Share Search": "Разрешить общий доступ к результатам поиска",
	"Share Time": "Разрешить общий доступ ко времени проигрывания",
	"There is no transcript available in the selected language.": "В выбранном языке не найдено текста.",
	"Show {{count}} more": "Отобразить больше {{count}}",
	"Show {{count}} more_plural": "Отобразить больше {{count}}"
};


//////////////////
// WEBPACK FOOTER
// ./locale/ru.json
// module id = ./locale/ru.json
// module chunks = 0 1